import React from "react";

import Ribbon from "../Components/UI/Ribbon";

const FamilyMembersLeaf = ({ 
    families, prefixClassName, displayUrl, ribbonText, modalTitle, activateModalTree 
}) => {
    return (
        <div
            className={`family-leaf family-leaf_${prefixClassName}`} 
            onClick={() => activateModalTree(families, modalTitle)}
        >
            <div className="family-leaf-image-border">
                <div className="family-leaf-image">
                    <img className="pic" src={displayUrl} alt={ribbonText} />
                </div>
            </div>
            <Ribbon
                text={ribbonText}
                leaf={"true"} 
            />
        </div>
    )
}

export default FamilyMembersLeaf;